export default __webpack_public_path__ + "static/media/SLIDE.d079db7b.jpg";